'use strict';

var mediator = require('../mediator'),
  $ = require('jquery'),
  _ = require('underscore'),
  events = require('../config').events,
  session = require('../session');

var REGEX_COLOUR = /white/;


var Share = function(el) {
  this.el = el;
  this.$el = $(el);
  this.initialize();
};

Share.prototype.initialize = function() {
  this.$el.on('click', _.bind(this.openShareEmail, this));
};

Share.prototype.openShareEmail = function(e) {
  e.preventDefault();

  mediator.trigger(events.share.modal, {
    shareLink: this.getShareLink(),
    originalLink: this.$el.attr('href'),
    colour: this.getHeaderColour(),
    title: this.$el.data('title') || '',
    image: this.$el.data('image') || false,
    username: session.sessionController.model.get('userDisplayName')
  });
};

Share.prototype.getShareLink = function() {
  var link = this.$el.attr('href');

  if (!link || link === '#' || link === 'undefined') {
    return window.location.href;
  }

  var scheme = window.location.protocol;
  var host = window.location.host;

  return scheme + '//' + host + link.replace(scheme, '').replace(host, '');
};

Share.prototype.getHeaderColour = function() {
  var colour = 'white'; // Default to white

  this.$el.parents().each(function() {
    var matches = this.className.match(REGEX_COLOUR);

    if (matches) {
      colour = matches[0];
      return false; // Break out of loop
    }
  });

  return colour;
};


Share.create = function($parent) {
  $parent.find('.Icon--share').each(function(n, el) {
    new Share(el);
  });
};

module.exports = Share;



// WEBPACK FOOTER //
// ./assets/js/components/Share.js